import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'react-feather';
import HeadquarterInput from './HeadquarterInput';
import cedesca from '../../../assets/images/logos/cedesca.jfif';
import cntec from '../../../assets/images/logos/cntec.jfif';
import colors from '../../../theme/colors';

const ListadoEmpresas = (props) => {
  const onChangeRadioValue = (e) => {
    props.setEmpresaId(e.target.value);
  };

  return (
    <div style={{
      backgroundColor: '#fff', borderRadius: '12px',
      border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
      overflow: 'visible',
    }}>
      {/* Toolbar */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 16px', borderBottom: '1px solid #f3f4f6',
      }}>
        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151' }}>
          Seleccionar empresa
        </span>
        <div style={{ display: 'flex', gap: '8px' }}>
          {props.beginning !== undefined && (
            <button
              type="button"
              onClick={props.beginning}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
                fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
                border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151',
                cursor: 'pointer', transition: 'all 0.15s',
              }}
            >
              <ChevronLeft size={13} />
              Volver fichar alumno
            </button>
          )}
          <button
            type="button"
            onClick={props.next}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
              fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
              border: `1px solid ${colors.primary}`, backgroundColor: '#fff', color: colors.primary,
              cursor: 'pointer', transition: 'all 0.15s',
            }}
          >
            Siguiente
            <ChevronRight size={13} />
          </button>
        </div>
      </div>

      <div style={{ padding: '16px' }}>
        <Row className="mb-3">
          <Col md="6" className="text-center">
            <HeadquarterInput headquarter="CEDESCA" imgUrl={cedesca} onChange={onChangeRadioValue} />
          </Col>
          <Col md="6" className="text-center">
            <HeadquarterInput headquarter="CNTEC" imgUrl={cntec} onChange={onChangeRadioValue} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

ListadoEmpresas.propTypes = {
  setEmpresaId: PropTypes.func,
  next: PropTypes.func,
  beginning: PropTypes.func,
};

export default ListadoEmpresas;
